/* src/app/features/users/pages/user-vacancy-form/user-vacancy-form.page.scss */
.page {
  display: flex;
  width: 100%;
  height: 840px;
  padding: 64px;
  margin: 64px auto;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}
.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo-container .logo {
  width: 336px;
}
@media (max-width: 1199px) {
  .logo-container .logo {
    width: 250px;
  }
}
.content-card-center {
  justify-content: center;
  align-items: center;
}
.content-card {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  min-height: calc(100vh - 220px);
}
@media (max-width: 1199px) {
  .content-card {
    min-height: calc(100vh - 110px);
  }
}
.content-card .vacancy-header {
  text-align: left;
  width: 100%;
}
.content-card .vacancy-header__title {
  color: var(--text-default);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin-bottom: 8px;
  margin-top: 0;
}
.content-card .vacancy-header__subtitle {
  color: var(--text-default);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
}
::part(scroll) {
  margin-top: 64px;
  padding: 64px;
}
@media (max-width: 1199px) {
  ::part(scroll) {
    margin-top: 72px;
    padding: 16px;
  }
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: var(--text-default);
  font-size: 16px;
}
.form-container {
  display: flex;
  max-width: 536px;
  padding: var(--spacing-Large, 32px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin: 0 auto;
}
@media (max-width: 1199px) {
  .form-container {
    width: 100%;
    padding: 16px;
  }
}
.form-container .form-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.form-container .form-field {
  width: 100%;
}
.form-container .checkbox-field {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 8px 0;
}
.form-container .checkbox-field label {
  color: var(--text-default);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}
.form-container .file-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-container .file-field .file-label {
  color: var(--text-default);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.form-container .file-field .file-input {
  padding: 8px;
  border: 1px solid var(--border-default);
  border-radius: 4px;
  background: var(--background-default);
  color: var(--text-default);
  font-size: 14px;
  cursor: pointer;
}
.form-container .file-field .file-input:hover {
  border-color: var(--border-hover);
}
.form-container .file-field .file-input:focus {
  outline: none;
  border-color: var(--primary-default);
}
.form-container .file-field .error-message {
  color: var(--error-default);
  font-size: 12px;
  line-height: 16px;
}
.form-container .outro-text {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.form-container .checkbox-container {
  margin-top: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.form-container .checkbox-container label {
  color: var(--text-label);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  cursor: pointer;
}
.form-container .checkbox-container label a {
  color: var(--primary-subtle-inverse);
  cursor: pointer;
}
.info-message-container {
  display: flex;
  padding: var(--component-content-card-padding, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--component-content-card-gap, 32px);
  flex: 1;
  flex-direction: column;
}
.info-message-container .info-message {
  display: flex;
  max-width: 362px;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
}
.info-message-container .info-message .info-message-title {
  color: var(--text-default);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.info-message-container .info-message .info-message-text {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.button-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/*# sourceMappingURL=user-vacancy-form.page.css.map */
